import { ConstantsUtil } from '@utils';
import { Routes } from '@enums';
import { Icon } from '@elements';
import { i18n } from '@localization';
import admins from '@images/admins.svg';
import groups from '@images/groups.svg';
import log from '@images/log.svg';
import logout from '@images/log-out.svg';
import profile from '@images/profile.svg';
import support from '@images/support.svg';
import users from '@images/users.svg';
import { jsx as _jsx } from "react/jsx-runtime";
var sideBarItems = [{
  id: '1',
  href: Routes.Home,
  icon: /*#__PURE__*/_jsx(Icon, {
    src: admins,
    width: 28,
    height: 28
  }),
  title: i18n.t('components.sideBar.pages.admins')
}, {
  id: '2',
  href: Routes.WisperUsers,
  icon: /*#__PURE__*/_jsx(Icon, {
    src: users,
    width: 28,
    height: 28
  }),
  title: i18n.t('components.sideBar.pages.wisperUsers')
}, {
  id: '3',
  href: Routes.Groups,
  icon: /*#__PURE__*/_jsx(Icon, {
    src: groups,
    width: 28,
    height: 28
  }),
  title: i18n.t('components.sideBar.pages.groups')
}, {
  id: '4',
  href: Routes.Log,
  icon: /*#__PURE__*/_jsx(Icon, {
    src: log,
    width: 28,
    height: 28
  }),
  title: i18n.t('components.sideBar.pages.log')
}];
var settingsItems = [{
  id: '1',
  icon: /*#__PURE__*/_jsx(Icon, {
    src: profile,
    width: 20,
    height: 20
  }),
  title: i18n.t('components.sideBar.pages.profileSettings'),
  href: Routes.Settings,
  mailLink: false
}, {
  id: '2',
  icon: /*#__PURE__*/_jsx(Icon, {
    src: support,
    width: 20,
    height: 20
  }),
  title: i18n.t('components.sideBar.pages.support'),
  href: "mailto:".concat(ConstantsUtil.email, "?subject=Support"),
  mailLink: true
}, {
  id: '3',
  icon: /*#__PURE__*/_jsx(Icon, {
    src: logout,
    width: 20,
    height: 20
  }),
  title: i18n.t('components.sideBar.pages.logOut'),
  href: Routes.Login,
  mailLink: false
}];
export { settingsItems, sideBarItems };